<script setup>
import {businessContact} from '@/utils/contact'

import Footer from "@/components/Footer.vue";
import HomeHeader from "@/components/HomeHeader.vue";
import {onMounted, onUnmounted} from "vue";
import EmailForm from "@/components/EmailForm.vue";
import {useHead} from "@vueuse/head";
import {useI18n} from "@/i18n";

const {t} = useI18n()

onMounted(() => {
  const scripts = [
    '/js/core.min.js',
    '/js/script.js'
  ];

  function loadScriptsSequentially(scripts, index = 0) {
    if (index < scripts.length) {
      const script = document.createElement('script');
      script.src = scripts[index];
      script.onload = () => loadScriptsSequentially(scripts, index + 1);
      document.body.appendChild(script);
    }
  }

  loadScriptsSequentially(scripts);
  window.addEventListener('popstate', handleBrowserNavigation)
})

useHead({
  title: 'TPA Housing - 100000m2 Production Plant, 20 Years Experienced Engineer, 30 Countries House Projects',
  meta: [
    {
      name: 'description',
      content: 'content="We can provide prefabricated design expertise, construction knowledge you need to build the house you want in short time and within your budget,Steel Structure House Building,Warehouse Steel Structure,Lightweight Steel Structure and other products and services'
    }
  ]
})

onUnmounted(() => {
  window.removeEventListener('popstate', handleBrowserNavigation)
})

function handleBrowserNavigation() {
  window.location.reload()
}

</script>

<template>
  <div class="page">
    <HomeHeader/>

    <!-- Breadcrumbs -->
    <section class="bg-gray-7">
      <div class="breadcrumbs-custom box-transform-wrap context-dark">
        <div class="container">
          <h3 class="breadcrumbs-custom-title" style="color: #0d0a0a">{{ t('page.contacts') }}</h3>
          <div class="breadcrumbs-custom-decor"></div>
        </div>
        <div class="box-transform" style="background-image: url(/images/bg-services.jpg);"></div>
      </div>
      <div class="container">
        <ul class="breadcrumbs-custom-path">
          <li><a href="/">{{ t('common.home') }}</a></li>
          <li class="active">{{ t('page.contacts') }}</li>
        </ul>
      </div>
    </section>
    <!-- True professionals-->
    <section class="section section-xl bg-default text-center">
      <div class="container">
        <h6 class="subtitle-classic wow fadeInRight">{{ t('home.professional') }}</h6>
        <h2 class="title-classic oh-desktop"><span class="d-inline-block wow slideInUp">{{ t('home.team') }}</span></h2>
        <article class="daisy-contact-card">
          <h3>{{ businessContact.name }}</h3>
          <a :href="businessContact.phoneHref"><i class="mdi mdi-phone" aria-hidden="true"></i><bdi>{{ businessContact.phone }}</bdi></a>
          <a :href="businessContact.emailHref"><i class="mdi mdi-email-outline" aria-hidden="true"></i><bdi>{{ businessContact.email }}</bdi></a>
          <a :href="businessContact.whatsappHref" target="_blank" rel="noopener"><i class="mdi mdi-whatsapp" aria-hidden="true"></i>{{ t('marketing.shared.whatsapp') }}: <bdi>{{ businessContact.phone }}</bdi></a>
        </article>
      </div>
    </section>
    <!-- Contacts-->
    <section class="section section-lg bg-default text-md-start">
      <div class="container">
        <div class="row row-60 justify-content-center">
          <div class="col-lg-8">
            <h4 class="text-spacing-25 text-transform-none">{{ t('common.getInTouch') }}</h4>
            <EmailForm/>
          </div>
          <div class="col-lg-4">
            <div class="aside-contacts">
              <div class="row row-30">
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">{{ t('form.phoneOptional') }}</p>
                  <div class="unit unit-spacing-xs justify-content-center justify-content-md-start">
                    <div class="unit-left"><span class="icon mdi mdi-phone"></span></div>
                    <div class="unit-body"><p>{{ businessContact.name }}</p><a dir="ltr" class="phone" :href="businessContact.phoneHref">{{ businessContact.phone }}</a></div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">{{ t('footer.email') }}</p>
                  <div class="unit unit-spacing-xs justify-content-center justify-content-md-start">
                    <div class="unit-left"><span class="icon mdi mdi-email-outline"></span></div>
                    <div class="unit-body"><a dir="ltr" class="mail" :href="businessContact.emailHref">{{ businessContact.email }}</a></div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">{{ t('marketing.shared.whatsapp') }}</p>
                  <div class="unit unit-spacing-xs justify-content-center justify-content-md-start">
                    <div class="unit-left"><span class="icon mdi mdi-whatsapp" aria-hidden="true"></span></div>
                    <div class="unit-body"><a dir="ltr" :href="businessContact.whatsappHref" target="_blank" rel="noopener">{{ businessContact.phone }}</a></div>
                  </div>
                </div>
                <div class="col-sm-6 col-lg-12 aside-contacts-item">
                  <p class="aside-contacts-title">Address</p>
                  <div class="unit unit-spacing-xs justify-content-center justify-content-md-start">
                    <div class="unit-left"><span class="icon mdi mdi-map-marker"></span></div>
                    <div class="unit-body"><a class="address" href="#">Factory building in Shiquanzhongqiao Development
                      Zone, Songgang, Shishan Town, Nanhai District, Foshan City;<br class="d-md-none">Gaotian Road,Mingcheng Town,Gaoming
                      District,Foshan, Guangdong,China</a></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer/>
  </div>
</template>

<style scoped>
.daisy-contact-card {
  --contact-radius: 12px;
  --contact-shadow: 0 12px 32px rgba(13, 38, 51, 0.08);
  display: grid;
  gap: 16px;
  max-width: 560px;
  margin: 32px auto 0;
  padding: clamp(20px, 5vw, 40px);
  border-radius: var(--contact-radius);
  box-shadow: var(--contact-shadow);
  text-align: start;
}

.daisy-contact-card a {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  min-width: 0;
  color: var(--mkt-blue, #126782);
}

.daisy-contact-card h3 {
  text-transform: none;
}

.daisy-contact-card bdi,
.aside-contacts .unit-body {
  min-width: 0;
  overflow-wrap: anywhere;
}
</style>
